import { position } from '@/api'
import { IsPC } from '@/utils'
export default {
  namespaced: true,
  state: {
    keyWords: '',
    key: '',
    category: [],
    list: [],
    searchList: [],
    details: null,
    total: 0,
    kind: {
      name: '全部职位',
      id: ''
    }
  },
  mutations: {
    SET_SEARCH_KEY(state, payload) {
      state.key = payload
    },
    SET_CATEGORY(state, payload) {
      state.category = payload
      state.title = payload[0].name
    },
    SET_CATEGORY_TITLE(state, payload) {
      state.kind.name = payload.name
      state.kind.id = payload.id
    },
    SET_LIST(state, payload) {
      if (!IsPC()) {
        state.list = state.list.concat(payload.list)
      } else {
        state.list = payload.list
      }
      state.searchList = payload.searchList || []
      state.total = payload.total
    },
    RESET_LIST(state) {
      state.list = []
    },
    SET_DETAILS(state, payload) {
      state.details = payload
    },
    SET_KEY_WORDS(state, payload) {
      state.keyWords = payload
    }
  },
  actions: {
    async GET_CATEGORY({ commit }, payload) {
      const res = await position.getCategory(payload)
      commit('SET_CATEGORY', [{ name: '全部职位', status: -1 }, ...res])
    },
    async GET_LIST({ commit }, payload) {
      const res = await position.getList(payload)
      commit('SET_LIST', { list: res.list, total: res.total })
    },
    async GET_SEARCH_LIST({ commit }, payload) {
      const res = await position.search(payload)
      commit('SET_LIST', { searchList: res })
    },
    async GET_DETAILS({ commit }, id) {
      const res = await position.getDetails({ id: id })
      commit('SET_DETAILS', res)
    }
  }
}

